import Image from "next/image";

import styles from "./styles.module.css";

export const ProductLogo = ({ src, alt }: { src: string; alt: string }) => {
  return (
    <figure className={styles.logo}>
      <Image
        src={src}
        alt={alt}
        width={72}
        height={29}
        style={{
          maxWidth: "100%",
          height: "auto",
        }}
      />
    </figure>
  );
};
